import EasyChat from '@components/LocalMerchant/EasyChat'
import Help from '@components/LocalMerchant/EasyChat/Help'

export default {
  path: 'easyChat',
  indexRoute: {
    component: EasyChat
  },
  stat: '轻松聊/首页',
  childRoutes: [
    {
      path: 'help',
      component: Help,
      stat: '轻松聊/帮助页'
    }
  ]
}
